import { routeData } from "@/router/constants/routes";

export function isVirtualRoute(routeName) {
    const matchedRoute = Object.values(routeData).find((route) => route.name === routeName);

    return matchedRoute?.virtual ?? false;
}
